module.exports = __webpack_public_path__ + "static/media/power.a743befe.svg";